import { Box, CircularProgress } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import { useFreemiumPhaseDetails } from "@trainwell/features/freemium-plans";
import { useEffect } from "react";
import { useButtonStore } from "src/components/ButtonState";
import { useTrainingPlanState } from "src/components/TrainingPlanState";
import TrainingPlanDetailsPageComponent from "src/features/plan-details/TrainingPlanDetailsPageComponent";

export const Route = createFileRoute("/_layout/trainingPlanDetails")({
  component: RouteComponent,
});

function RouteComponent() {
  const selectedPlan = useTrainingPlanState((plan) => plan.selectedPlan);

  const setButtonVisible = useButtonStore((state) => state.setVisible);

  useEffect(() => {
    setButtonVisible(true);
  }, [setButtonVisible]);

  const { data: phaseDetails, isPending } = useFreemiumPhaseDetails({
    filter: {
      planId: selectedPlan?.plan.plan_template_id || "",
      phaseId: selectedPlan?.plan.training_plan_phases[0].id?.toString() || "",
      detailed: true,
    },
  });

  if (isPending) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <CircularProgress />
      </Box>
    );
  }

  // TODO(akrulec): Handle this empty state better.
  return selectedPlan ? (
    <TrainingPlanDetailsPageComponent
      plan={selectedPlan}
      phaseDetails={phaseDetails}
    />
  ) : null;
}
